// extracted by mini-css-extract-plugin
export var cardLayout = "_6p-1";
export var paginationContainer = "_6p-0";